module.exports = __webpack_public_path__ + "img/222.b200c683.jpg";